var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"expect_goal"},[_c('div',{staticClass:"expectGoal_box",on:{"click":function($event){$event.stopPropagation();return _vm.downLoad.apply(null, arguments)}}},[_c('div',{ref:"expectGoal",class:_vm.echartData.objectInfos.length === 2 ? 'expectGoal2' : 'expectGoal1'})])])
}
var staticRenderFns = []

export { render, staticRenderFns }